//import { Kursteilnehmer } from "./teilnehmer";
//import { Time } from "@angular/common";
//import { nearer } from "q";
//import { validateConfig } from "@angular/router/src/config";
//import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";
//import { Excuse } from "../enums/excuse.enum";

export class Fehlzeiten {
  constructor(_tnid: number, _entschuldigt?: boolean, _entschuldigung?: string, _datum?: string) {
    this.setAktZ();
    this.fehlzeitenId = 0;
    this.entschuldigt = false;
    this.entschuldigung = "";
    this.kursteilnehmerNr = _tnid;
    this.datum = Fehlzeiten.jsDatetoString(_datum);
    this.entschuldigt = _entschuldigt;
    this.entschuldigung = _entschuldigung;
  }
  //"2018-10-31T00:00:00"
  fehlzeitenId: number;
  kursteilnehmerNr: number;
  von: string;
  bis: string;
  entschuldigt: boolean;
  entschuldigung: string;

  get excuse(): string {
    if (this.entschuldigung == "") return this.excuses[3];
    else return this.entschuldigung;
  }

  excuses: string[] = [
    "entschuldigt",
    "krank",
    "Sonderurlaub",
    "unentschuldigt"
  ];
  //get excuses():string[] {
  //  return Fehlzeiten._excuses;
  //}

  datum: string;
  teilnehmer: any;

  public static GanzerTag(tnnr: number, _datum?: string): Fehlzeiten {
    let fz = new Fehlzeiten(tnnr);
    fz.datum = _datum;
    fz.von = "08:15";
    fz.bis = "16:30";
    return fz;
  }
  static jsDatetoString(_datum?: string): string {
    let d = new Date();
    if (_datum != undefined) {
      return _datum;
    }
    let m = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    if (day.length < 2) {
      day = "0" + day;
    }
    if (m.length < 2) {
      m = "0" + m;
    }
    return d.getFullYear() + "-" + m + "-" + day + "T00:00:00";
  }
  setAktZ() {
    if (!this.von && !this.bis) {
      let temp = new Date();
      let mittag = new Date(temp.getFullYear(), temp.getMonth(), temp.getDate(), 12, 0)

      if (temp.getTime() <= mittag.getTime()) {

        this.setAktbis();
        this.von = "08:15";
      }
      else {
        this.bis = "16:30";
        this.setAktvon();
      }
    }
  }
  public setAktvon(): void {
    this.von = Fehlzeiten.aktuelleZeit();
  }
  public setAktbis(): void {
    this.bis = Fehlzeiten.aktuelleZeit();
  }
  static aktuelleZeit(): string {
    let temp = new Date();
    let aktH = temp.getHours().toString();
    let aktM = temp.getMinutes().toString();
    if (aktH.length < 2) {
      aktH = "0" + aktH;
    }
    if (aktM.length < 2) {
      aktM = "0" + aktM;
    }
    return aktH + ":" + aktM;
  }

  onApologyChanged(apology: string) {

  }
}



// WEBPACK FOOTER //
// ./src/app/_models/fehlzeiten.ts